// Header fields of hlod-tileset node payloads (`HSHL`), read without decoding the payload. The
// decoder in formats/hlod validates the whole header; the payload cache only needs the version,
// which tells a JPEG atlas (1) from a KTX2 atlas (2) and so whether a cached node can still change.

const HLOD_MAGIC: number[] = [0x48, 0x53, 0x48, 0x4c]; // "HSHL"
const HLOD_HEADER_SIZE: number = 32;

/** Payload version 1 carries a JPEG atlas; the deferred KTX2 pass replaces it by version 2 under the same id. */
export const HS_HLOD_PAYLOAD_VERSION_JPEG: number = 1;
export const HS_HLOD_PAYLOAD_VERSION_KTX2: number = 2;

/** The payload version of an `HSHL` node payload, or null for any other document (manifests are JSON). */
export function hsHlodPayloadVersion(payload: ArrayBuffer): number | null {
  if (payload.byteLength < HLOD_HEADER_SIZE) {
    return null;
  }
  const bytes: Uint8Array = new Uint8Array(payload, 0, HLOD_HEADER_SIZE);
  if (HLOD_MAGIC.some((value: number, index: number) => bytes[index] !== value)) {
    return null;
  }
  return new DataView(payload, 0, HLOD_HEADER_SIZE).getUint16(4, true);
}
